import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { formatPercent } from "../../lib";

type Row = {
  category: string;
  ord: number;
  job_count: number | string;
};

// Non-deleted schools bucketed by lifetime non-draft jobs posted, from
// GET /api/stats/school-engagement. Superuser only.
export const school_engagement: Query<Ctx> = async ({ sb }, _params) => {
  const { data, error } = await sb.functions.invoke<Row[] | null>(
    "api/stats/school-engagement",
    { method: "GET" }
  );
  if (error) console.error("school_engagement:", error);
  const rows = data ?? [];

  const total_jobs = rows.reduce((sum, r) => sum + Number(r.job_count), 0);

  return rows.map((row) => {
    const job_pct = total_jobs > 0 ? Number(row.job_count) / total_jobs : null;
    return {
      category: row.category,
      job_count: Number(row.job_count),
      job_pct,
      f_job_pct: formatPercent(job_pct),
    };
  });
};
